import { Component } from '@angular/core';
import { EthernetDevice } from '@oblac/motion-master-client';
import { MotionMasterConnectionService, MotionMasterService } from '@oblac/shared/data-access';

@Component({
  selector: 'oblac-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  constructor(private mm: MotionMasterService, private connectionService: MotionMasterConnectionService) {
    this.connectionService.hydrateConnection();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window['mm'] = this.mm;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window['client'] = this.mm.client;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window['EthernetDevice'] = EthernetDevice;
  }
}
